export function agentHeartbeatActive(
  status: string | undefined,
  lastSeenAt: string | null | undefined,
  now = Date.now(),
): boolean {
  if (status !== 'ONLINE' || !lastSeenAt) return false;
  const elapsed = now - Date.parse(lastSeenAt);
  return Number.isFinite(elapsed) && elapsed >= 0 && elapsed < 5 * 60_000;
}

/** Keep the dashboard usable while Pages and the Worker roll out separately. */
export function agentDetails(agent: {
  name: string;
  version?: string;
  capabilities?: string[];
  last_seen_at: string | null;
}): string {
  const lastSeen = agent.last_seen_at
    ? new Date(agent.last_seen_at).toLocaleString('pt-BR')
    : 'nunca';
  return `${agent.name} · versão ${agent.version ?? 'não informada'} · FFmpeg ${agent.capabilities?.includes('ffmpeg') ? 'disponível' : 'não informado'} · último contato ${lastSeen}`;
}
